module.exports = __webpack_public_path__ + "media/fonts/bootstrap-icons-94eeade1.woff";